import type { CareerCenter, CareerCenterResponse } from "@/modules/careerCenter/types"
import type { NextRequest } from "@/modules/fetch/types"
import type { I18nLocale } from "@/modules/i18n/types"

import { getApiUrl } from "@/modules/api/api"
import { keysToCamelCase } from "@/modules/apiRequests/dataStructure"
import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"

type GetCareerCenterParams = {
  hostname: string
  locale: I18nLocale
  permalink: string
  req?: NextRequest
}

const CAREER_CENTER_ENDPOINT = "/jobteaser.context.v1alpha1/ContextService/GetCareerCenter"

export const getCareerCenter = async ({
  hostname,
  locale,
  permalink,
  req,
}: GetCareerCenterParams): Promise<CareerCenter> => {
  if (!permalink) {
    throw new Error(`Missing permalink when fetching career center.`)
  }

  return fetcher(
    getApiUrl({ hostname, path: CAREER_CENTER_ENDPOINT }),
    {
      body: JSON.stringify({ locale, permalink }),
      method: "POST",
    },
    { nextRequest: req, serviceDomain: "GATEWAY_API" }
  )
    .then(getResultFromResponse<CareerCenterResponse>({ transformResult: keysToCamelCase<CareerCenterResponse> }))
    .then(({ careerCenter }) => careerCenter)
    .catch(handleFetchError(CAREER_CENTER_ENDPOINT))
}
